import { render, staticRenderFns } from "./ProfitManagement.vue?vue&type=template&id=f7474a54&scoped=true&"
import script from "./ProfitManagement.vue?vue&type=script&lang=js&"
export * from "./ProfitManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProfitManagement.vue?vue&type=style&index=0&id=f7474a54&lang=scss&scoped=true&"
import style1 from "./ProfitManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7474a54",
  null
  
)

export default component.exports